import Notification from '@@types/Notification';

import NoStyleButton from '~/components/common/Button/NoStyle';
import * as React from 'react';

type Props = {
  notification: Notification;
};

const colorStyle: React.CSSProperties = {
  color: '#125de6',
};

const NotificationActionButton: React.FC<Props> = ({ notification }) => {
  const { action } = notification;

  return action && action.label ? (
    <div>
      <NoStyleButton onClick={action.callback} widthAuto>
        <span style={colorStyle}>{action.label}</span>
      </NoStyleButton>
    </div>
  ) : null;
};

export default NotificationActionButton;
